import { urlPrefix, urlToken } from '~/config/i18n.pages'
import { TALENT_POOL_NAMES } from '~/enum/positions'

export default {
  props: {
    id: {
      type: String | Number,
      required: true,
    },

    title: {
      type: String,
      required: true,
    },

    office: {
      type: Object | String,
    },
    gtm: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      urlToken,
      urlPrefix,
      cardConfig: {
        cardType: '',
        background: {
          class: '',
        },
        main: {
          class: '',
        },
        article: {
          class: '',
        },
        header: {
          class: '',
        },
        body: {
          class: '',
        },
        footer: {
          class: '',
        },
      },
    }
  },

  computed: {
    hasOffice() {
      const hasOffice = this.office
      if (hasOffice) return true
    },

    isRed() {
      const talentPoolName = TALENT_POOL_NAMES[this.$i18n.locale]

      return this.title?.toLowerCase().trim().includes(talentPoolName)
    },
  },
}
